import React from "react";

interface IFormButtonProp {
  canClick: boolean;
  loading: boolean;
  actionText: string;
}

export const FormButton: React.FC<IFormButtonProp> = ({
  canClick,
  loading,
  actionText,
}) => (
  <button
    className={`text-lg w-full select-none font-medium focus:outline-none text-white py-2  transition-colors  ${
      canClick ? "bg-[#A72B2A]" : "bg-gray-300 pointer-events-none "
    }`}
  >
    {loading ? "Loading..." : actionText}
  </button>
);
